import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { UpdateRetailOrderResult } from "../types/UpdateRetailOrderResult";

export const useSubmitTemplateChecklist = (
	retailOrderID: number,
	onSuccess: (result: UpdateRetailOrderResult) => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/submit-checklist",
				{
					retailOrderID: retailOrderID
				}) as UpdateRetailOrderResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when submitting template checklist: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
